import websocketPlugin from './websocket-plugin'

export default [
    websocketPlugin
]
